import React from 'react';
import { useSelector } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import DesignNameDialog from './DesignNameDialog';
import { useTranslation } from 'react-i18next';

const DesignName = () => {
	const { t } = useTranslation();
	const userLoggedIn = useSelector(state => state.user.loggedIn);
	const userId = useSelector(state => state.user.id);
	const myDesign = useSelector(state => state.selectedDesign.myDesign);

	return userLoggedIn && userId !== null ? (
		<Grid container alignItems="center" spacing={1}>
			<Grid item>
				<Typography display="inline" variant="subtitle1">
					{myDesign.name}
				</Typography>
			</Grid>

			<Grid item>
				<DesignNameDialog />
			</Grid>
		</Grid>
	) : (
		<Typography variant="subtitle1">{t('components.design.designSummary')}</Typography>
	);
};

export default DesignName;
